import styled from 'styled-components';

export const RadioCardContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RadioCardContent = styled.div`
  display: flex;
`;

export const StyledHeader = styled.div`
  font-family: ${props => props.theme.fonts.circular};
  font-size: ${props => props.theme.fontSizes.headerFour};
  font-weight: 500;
  color: ${props => props.theme.colors.capsuleGreen60};
  margin-bottom: 1rem;
  text-transform: uppercase;
`;
